import { navLinks } from "@/mocks/portal";

export default function Footer() {
  return (
    <footer className="border-t border-background-200 bg-background-50">
      <div className="mx-auto max-w-[1200px] px-4 pb-8 pt-10 md:px-6">
        <div className="grid grid-cols-1 gap-8 border-t border-background-200 pt-8 md:grid-cols-[1.4fr_1fr_1fr] md:gap-6">
          <div>
            <a href="#top" className="flex items-center gap-2.5">
              <span className="grid h-9 w-9 place-items-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-shuffle-line text-lg" aria-hidden="true" />
              </span>
              <span className="text-[15px] font-bold text-foreground-950">吃瓜线路</span>
            </a>
            <p className="mt-3 max-w-sm text-[13px] leading-6 text-foreground-600">
              一个围绕切换指南、多线选择、线路对比与速度测试整理的参考站，专注帮不同网络环境判断哪个好用。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-bold text-foreground-950">浏览索引</h3>
            <ul className="mt-3 flex flex-col gap-2">
              {navLinks.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="text-[13px] text-foreground-600 transition-colors hover:text-primary-600">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-bold text-foreground-950">使用提示</h3>
            <ul className="mt-3 flex flex-col gap-2 text-[13px] text-foreground-600">
              <li className="flex items-center gap-2">
                <i className="ri-information-line text-primary-500" aria-hidden="true" />
                数据为参考样本
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-refresh-line text-primary-500" aria-hidden="true" />
                定期刷新更准确
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-lock-line text-primary-500" aria-hidden="true" />
                隐私与安全请遵循工具说明
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-3 border-t border-background-200 pt-5 sm:flex-row">
          <p className="text-[12px] text-foreground-500">© 2026 吃瓜线路 · 切换指南参考站，仅供浏览参考。</p>
          <p className="flex items-center gap-1.5 text-[12px] text-foreground-500">
            <i className="ri-speed-line text-primary-500" aria-hidden="true" />
            速度测试与线路对比仅作趋势参考
          </p>
        </div>
      </div>
    </footer>
  );
}